// Actions constants should be mapped in the same order
// as they are defined in the actions file.
export const ACTIONS = {
  SET_PAYMENTS: 'set_payments',
  CLEAR_PAYMENTS: 'clear_payments',
  DELETE_PAYMENT: 'remove_payment',
  SET_DEFAULT: 'set_default_payment'
};
